<template>
  <div v-if="!item.RestrictAddress">
    <div v-if="isFuture">
      <div
        v-if="
          (item.PROPERTYADDRESS1 && item.PROPERTYCITY) ||
            (item.MAILINGADDRESS1 && item.MAILINGCITY)
        "
        class="row"
      >
        <div v-if="item.PROPERTYADDRESS1" class="col">
          <h1 class="mb-0">{{ item.PROPERTYADDRESS1 }}</h1>
          <span v-if="item.PROPERTYADDRESS2">
            {{ item.PROPERTYADDRESS2 }}
          </span>

          <p v-if="item.PROPERTYCITY" class="lead">
            {{ item.PROPERTYCITY }}, {{ item.PROPERTYSTATE }}
            {{ item.PROPERTYZIPCODE }}
          </p>
        </div>
        <div v-else class="col">
          <h4 class="mb-0">No Listed Property Address</h4>
        </div>
        <div
          v-if="
            lteURL &&
              county.lteInstalled &&
              parcel.propertyInfo.taxType != 'Personal'
          "
          class="col dropdown-button"
        >
          <a
            :href="lteURL"
            class="rounded flex-button m-3 text-decoration-none button-label  d-print-none"
            rel="noopener"
            target="_blank"
            >File E-Forms</a
          >
        </div>
      </div>
    </div>
    <div v-else>
      <div
        v-if="
          (item.PROPERTYADDRESS1 && item.PROPERTYCITY) ||
            (item.MAILINGADDRESS1 && item.MAILINGCITY)
        "
        class="row"
      >
        <div v-if="item.PROPERTYADDRESS1" class="col">
          <h1 class="mb-0">{{ item.PROPERTYADDRESS1 }}</h1>
          <span v-if="item.PROPERTYADDRESS2">
            {{ item.PROPERTYADDRESS2 }}
          </span>

          <p v-if="item.PROPERTYCITY" class="lead">
            {{ item.PROPERTYCITY }}, {{ item.PROPERTYSTATE }}
            {{ item.PROPERTYZIPCODE }}
          </p>
        </div>
        <div v-else class="col">
          <h4 class="mb-0">No Listed Property Address</h4>
        </div>
        <div class="col">
          <div class="owner-sub-address">
            <h4 class="mb-0">{{ item.OwnerName }}</h4>
            <span>{{ item.MAILINGADDRESS1 || item.PROPERTYADDRESS1 }}</span>

            <span v-if="item.MAILINGADDRESS2"
              ><br />
              {{ item.MAILINGADDRESS2 }}
            </span>
            <span
              v-else-if="
                !item.MAILINGADDRESS1 &&
                  item.PROPERTYADDRESS1 &&
                  item.PROPERTYADDRESS2
              "
            >
              {{ item.PROPERTYADDRESS2 }}
            </span>
            <br />
            <span v-if="item.MAILINGCITY">
              {{ item.MAILINGCITY }}, {{ item.MAILINGSTATE }}
              {{ item.MAILINGZIPCODE }}
            </span>
          </div>
        </div>
      </div>
      <div v-else class="row">
        <div class="col">
          <h4 class="mb-0">No Listed Property Address</h4>
        </div>
        <div class="col">
          <h4 class="mb-0 text-end">{{ item.OwnerName }}</h4>
          <div class="owner-sub-address">
            <span>No Listed Mailing Address</span>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div
          v-if="item.Photo && !imageErrorPresent"
          :class="'col-12 col-sm-6 mt-4'"
        >
          <img
            alt="photo of property"
            class="parcel-photo img-fluid"
            :src="
              item.Photo.substring(0, 4).toLowerCase() == 'http'
                ? item.Photo
                : county.photoUrlPrefix + item.Photo
            "
            @error="fixPhoto404"
          />
        </div>
        <div
          :class="
            (!imageErrorPresent && item.Photo) || isMobile == 'mobile'
              ? 'col-12 col-sm-6'
              : 'w-65'
          "
        >
          <pay-container
            v-if="!isPastYear"
            :billingSummary="this.billingSummary"
            :county="county"
            :isFuture="isFuture"
            :isPastYear="isPastYear"
            :payYear="currentPayYear"
            :dup="parseInt(item.BillingDuplicateNumber)"
            :stateKey="item.StateKey"
            :unformattedStateKey="item.UNFORMATEDSTATEKEY"
            :taxType="item.TaxType"
            :parcelStatus="item.Status"
            :id="
              (!imageErrorPresent && item.Photo) || isMobile == 'mobile'
                ? 'image-present-pay-container'
                : ''
            "
            :imagePresent="item.Photo ? true : false"
          />
          <div
            v-else
            class="d-flex align-items-center h-100 justify-content-center flex-column mt-2 h5"
          >
            This is a historic pay year. Please go to the
            <a :href="currentYearUrl">Current Pay Year</a> to view balance, pay
            bill, and more.
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div v-if="showMap && item.UNFORMATEDSTATEKEY.length > 0">
          <arcgis-map
            :county="county"
            :currentPayYear="currentPayYear"
            :restApiUrl="county.mapping.arcgis.rest_api_url"
            :parcel="item"
            @parcelMapped="parcelMapped"
          />
        </div>
      </div>
    </div>
  </div>
  <div v-else class="d-flex w-100 flex-column">
    <h1>Restricted</h1>
    <div class="row mt-4">
      <div v-if="showMap && item.UNFORMATEDSTATEKEY.length > 0">
        <arcgis-map
          :county="county"
          :currentPayYear="currentPayYear"
          :restApiUrl="county.mapping.arcgis.rest_api_url"
          :parcel="item"
          @parcelMapped="parcelMapped"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>
.parcel-photo {
  min-height: 200px;
  max-height: 400px;
}
.owner-sub-address {
  line-height: 1rem;
  margin-top: 0.5rem;
  text-align: right;
}
.owner-sub-address span {
  font-weight: 500;
}
.w-65 {
  width: 65%;
}
</style>

<script>
import ArcgisMap from "./ArcgisMap.vue";
import PayContainer from "./PayContainer.vue";
export default {
  components: {
    ArcgisMap,
    PayContainer,
  },
  data() {
    return {
      parcelMapSuccessful: false,
      imageErrorPresent: false,
    };
  },
  methods: {
    fixPhoto404(el) {
      el.target.remove();
      this.imageErrorPresent = true;
    },
    parcelMapped(wasSuccessful) {
      this.parcelMapSuccessful = wasSuccessful;
    },
  },
  computed: {
    isPastYear() {
      return this.item.PAYYEAR < parseInt(this.currentPayYear);
    },
    currentYearUrl() {
      return `/${this.county.slug}/${this.item.BillingDuplicateNumber}`;
    },
  },
  props: {
    county: {
      type: Object,
      required: true,
    },
    currentPayYear: {
      type: Number,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    isFuture: {
      type: Boolean,
      required: false,
      default: false,
    },
    billingSummary: {
      type: Object,
      required: true,
    },
    showMap: {
      type: Boolean,
      required: false,
      default: false,
    },
    isMobile: {
      type: String,
      required: true,
    },
  },
};
</script>
